// @ts-nocheck
/* eslint-disable */
export const minusCirlceIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1.333C4.327 1.333 1.334 4.327 1.334 8S4.326 14.667 8 14.667 14.667 11.673 14.667 8 11.674 1.333 8 1.333M10.614 8.5H5.28a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h5.334a.5.5 0 1 1 0 1"/></svg>`,
    name: 'minus-cirlce' as const
};